export default class CookieLayer {
  constructor( node ) {
    this.node = node;
    this.close = this.node.querySelector( '.cookie-layer-close' );
    this.handleCookie();
  }

  handleCookie() {
    // this.removeCookie( 'cookielayer=' );
    let cookie = this.getCookie( 'cookielayer=' );
    let optOut = this.getCookie( 'et_oi_v2' );

    if ( typeof _etracker !== 'undefined' ) {
      if ( _etracker.isOptInDialogExpected()) {
        // _etracker.enableTracking();
      } else if ( optOut === 'no' ) {
        this.deleteAllCookies();
      }
    }

    if ( cookie === '' ) {
      this.node.classList.add( 'cookie-layer-outer--show' );
      this.close.addEventListener( 'click', () => {
        this.setCookie( 'cookielayer=', 30 );
        this.node.classList.remove( 'cookie-layer-outer--show' );
      });
    }
  }

  getCookie( name ) {
    let decodedCookie = decodeURIComponent( document.cookie );
    let ca = decodedCookie.split( ';' );

    for ( let i = 0; i < ca.length; i++ ) {
      let c = ca[ i ];
      while ( c.charAt( 0 ) === ' ' ) {
        c = c.substring( 1 );
      }
      if ( c.indexOf( name ) === 0 ) {
        return c.substring( name.length, c.length );
      }
    }
    return '';
  }
  setCookie( name, days ) {
    let currentDate = new Date();
    currentDate.setTime( currentDate.getTime() + ( days * 24 * 60 * 60 * 1000 ));
    let expires = 'expires=' + currentDate.toUTCString();
    document.cookie = name + 'true; ' + expires + '; path=/';
  }
  removeCookie( name ) {
    document.cookie = name + '; expires=' + new Date().toUTCString() + '; path=/';
  }
  deleteAllCookies() {
    let cookies = document.cookie.split( ';' );

    for ( let i = 0; i < cookies.length; i++ ) {
      let cookie = cookies[ i ];
      let eqPos = cookie.indexOf( '=' );
      let name = eqPos > -1 ? cookie.substr( 0, eqPos ) : cookie;
      if ( name.includes( 'et_oi_v2' ) || name.includes( 'cookie-agreed' )) {
        // do nothing
      } else {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;Path=/';
      }
    }
  }
}
